/* ============
 * Getters for the patient module
 * ============
 *
 * The getters that are available on the
 * patient module.
 */
import { clone } from '@/utils/object';

const getPatients = state => clone(state.patients);
const getPatient = state => clone(state.patient);
const getLoading = state => clone(state.loading);
const getTotalCount = state => clone(state.totalCount);
const getPatientStatusCount = status => clone(status.patienStatusCount);
const getIsPatientListloading = state => clone(state.isPatientsloading);
const getPatientDataToMsg = state => clone(state.patientDataToMsg);

export default {
  getPatients,
  getPatient,
  getLoading,
  getTotalCount,
  getPatientStatusCount,
  getIsPatientListloading,
  getPatientDataToMsg
};
